export const environment = {
  production: false,
  posthogKey: 'phc_dGLcuMcEeheYGmYDFgbkS5IlrQlmswa8Tm51Ws3Fz8y',
  posthogHost: 'https://us.i.posthog.com', // o https://eu.i.posthog.com según tu proyecto
};
